import { CoreIcon } from '../core-icon';
import parkinglotColorSVG from '../../assets/icons/parkinglot-color.svg';
import type { IconProps } from '../core-icon';

export const ParkinglotColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={parkinglotColorSVG} {...props} />;
};
